import { Card } from '@innovationnorway/component-library';
import React from 'react';

type Props = {
  note: string;
  receivingActor: string;
  opportunityTitle: string;
  fromActorName: string;
  handlerName?: string;
};

const ReferralMailActor: React.FC<Props> = ({
  note,
  receivingActor,
  opportunityTitle,
  fromActorName,
  handlerName,
}) => {
  return (
    <Card className="email-preview padding--2 stack-medium font-size--medium">
      <p>
        Aktør <b>{receivingActor}</b>, har mottatt ny henvisning fra aktør <b>{fromActorName}</b>. Tittel på
        henvendelsen: <em>{opportunityTitle}</em>. Gå til <b>flerbedriftsportal.no</b> for å følge opp
        kunden/henvendelsen.
      </p>
      <p>Melding fra {fromActorName}:</p>
      <p className="white-space--pre-wrap">{note}</p>
      {handlerName && <p>Med vennlig hilsen {handlerName}</p>}
      <p>MERK: Svar til denne e-postadressen blir ikke behandlet.</p>
    </Card>
  );
};

export default ReferralMailActor;
